import { collection,onSnapshot, orderBy, query} from "firebase/firestore";
import { useEffect, useState } from "react";
import db  from "./Backend";
import CommentContent from "./CommentContent";
import format from "date-fns/format";

const CommentCollection = ({programID, roomKey}) => {
    const [comment,setComment] = useState([]);
    const today = format(new Date(),"yyyy-MM-dd");
  

        useEffect(()=>{
            if (programID) {
                const collectionRef = collection(db, programID);
                const q = query(collectionRef, orderBy("timestamp","asc"));
    
                const unsub = onSnapshot(q, (snapshot) => {
                    const items =[];
                    snapshot.forEach((doc) => {
                        items.push(doc.data());
                    });
                    setComment(items);
                });
                return unsub;
            }
          
        },[today, programID]);
      

    return ( 
        <div className={`comment-collection ${roomKey ? 'bethel-cast' : 'radio'}`}>
           {comment && comment.map(m => (
            <CommentContent 
                key={m.timestamp}
                message = {m.message}
                user_name ={m.user_name}
                dateSent ={m.dateSent}
                currentTime = {m.currentTime}
                emoji = {m.emoji}
                timestamp = {m.timestamp}
            />

           ))}
        </div>
     );
}
export default CommentCollection;